module.exports = __webpack_public_path__ + "img/logo.8a49d6fd.png";